import React from 'react';

// --- IMPORT YOUR BUILDERS ---
import MasterBlasterBuilder from './builders/MasterBlasterBuilder';
import IWBBuilder from './builders/IWBBuilder';
import RevolverBuilder from './builders/RevolverBuilder';
import DaishoBuilder from './builders/DaishoBuilder';
import CradleBuilder from './builders/CradleBuilder';
import OWBBuilder from './builders/OWBBuilder';
import NidhoggBuilder from './builders/NidhoggBuilder'; 
import NidhoggLvl2Builder from './builders/NidhoggLvl2Builder'; 
import MagCarrierBuilder from './builders/MagCarrierBuilder';
import RifleMagBuilder from './builders/RifleMagBuilder'; 
import PlacardBuilder from './builders/PlacardBuilder';
import AceVRBuilder from './builders/AceVRBuilder';
// --- NEW LIMITED EDITION IMPORT ---
import LimitedEditionBuilder from './builders/LimitedEditionBuilder';

function App() {
  const currentPath = window.location.pathname.toLowerCase();

  // 1. IGNORE ASSET PATHS (Fixes the "images" bug)
  // If the URL looks like a file request (images, css, etc.), do nothing or return null
  if (currentPath.startsWith("/images") || currentPath.includes("static")) {
     return null; 
  }

  // 2. ROUTING LOGIC
  let ActiveBuilder = <MasterBlasterBuilder />; // Default fallback

  if (currentPath.includes("limited")) {
    ActiveBuilder = <LimitedEditionBuilder />;
  } else if (currentPath.includes("master-blaster")) {
    ActiveBuilder = <MasterBlasterBuilder />;
  } else if (currentPath.includes("iwb")) {
     ActiveBuilder = <IWBBuilder />;
  } else if (currentPath.includes("daisho")) {
     ActiveBuilder = <DaishoBuilder />;
  } else if (currentPath.includes("revolver")) {
     ActiveBuilder = <RevolverBuilder />;
  } else if (currentPath.includes("cradle")) {
     ActiveBuilder = <CradleBuilder />;
  } else if (currentPath.includes("owb")) {
     ActiveBuilder = <OWBBuilder />;
  } else if (currentPath.includes("ace-vr") || currentPath.includes("acevr")) {
   ActiveBuilder = <AceVRBuilder />;
} else if (currentPath.includes("nidhogg") && (currentPath.includes("l2") || currentPath.includes("lvl2") || currentPath.includes("level2"))) {
     ActiveBuilder = <NidhoggLvl2Builder />;
  } else if (currentPath.includes("nidhogg")) {
     ActiveBuilder = <NidhoggBuilder />;
  } else if (currentPath.includes("rifle")) {
      ActiveBuilder = <RifleMagBuilder />;
  } else if (currentPath.includes("mag") && !currentPath.includes("images")) {
      ActiveBuilder = <MagCarrierBuilder />;
  } else if (currentPath.includes("placard")) {
      ActiveBuilder = <PlacardBuilder />;
  }

  // 3. RENDER WRAPPED APP
  // This matches the scoped CSS we created to prevent style leaking!
  return (
    <div id="anr-holster-builder" className="App">
       {ActiveBuilder}
    </div>
  );
}

export default App;